let Widget3dsoft = require('./Main.js');

/**
     * 
     * @returns {undefined}
     */
Widget3dsoft.prototype.updateRendezvous = function (widget, key, keyRdv) {
    var self = widget;
    $('#widget3Dsoft-loading').show();
    var oRdv = self.aSearchClientRdvs[key][keyRdv];

    self.updateRdvActif = true;
    self.rendezvous.iIdRendezvous = keyRdv;

    //Client
    self.rendezvous.iIdClient = oRdv._CLI_ID;
    self.rendezvous.civilite = self.aClients[oRdv._CLI_ID].civ_id;
    self.rendezvous.sNom = self.aClients[oRdv._CLI_ID].nom;
    self.rendezvous.sPrenom = self.aClients[oRdv._CLI_ID].prenom;
    self.rendezvous.telmob = self.aClients[oRdv._CLI_ID].tel_gsm;
    self.rendezvous.teldom = self.aClients[oRdv._CLI_ID].tel_dom;
    self.rendezvous.telbur = self.aClients[oRdv._CLI_ID].tel_bur;
    self.rendezvous.email = self.aClients[oRdv._CLI_ID].email;
    self.rendezvous.adresse = self.aClients[oRdv._CLI_ID].adresse1;
    self.rendezvous.cp = self.aClients[oRdv._CLI_ID].code_postal;
    self.rendezvous.ville = self.aClients[oRdv._CLI_ID].ville;


    //Vehicule
    self.aVehicules = self.searchVehiculesClient(self, self.rendezvous.iIdClient,function (aVehicules) {

        self.aVehicules = aVehicules;
        self.rendezvous.iIdVehicule = oRdv._VEH_ID;
        self.rendezvous.sImmatriculation = self.aVehicules[oRdv._VEH_ID]._VEH_IMMATRICULATION;
        self.rendezvous.iIdMarque = self.aVehicules[oRdv._VEH_ID]._MAR_ID;
        self.rendezvous.iIdModele = self.aVehicules[oRdv._VEH_ID]._MOD_ID;
        self.rendezvous.sVin = self.aVehicules[oRdv._VEH_ID]._VEH_NO_SERIE;
        self.rendezvous.iKm = self.aVehicules[oRdv._VEH_ID]._VEH_KILOMETRAGE;
        self.rendezvous.sDateMec = self.aVehicules[oRdv._VEH_ID]._VEH_DATE_MEC;


        //Interventions
        self.searchInterventions(self,self.rendezvous.iIdModele,function(){
            self.rendezvous.aTravaux = [];
            self.rendezvous.aInterventions = [];
            for (iKeyItv in oRdv._INTERVENTIONS_LIST) {
                if(oRdv._INTERVENTIONS_LIST[iKeyItv]._INT_ID == 0){
                    self.rendezvous.aTravaux.push(oRdv._INTERVENTIONS_LIST[iKeyItv]);
                }else{
                    self.rendezvous.aInterventions.push(oRdv._INTERVENTIONS_LIST[iKeyItv]._INT_ID);
                }
            }

            //self.rendezvous.iDureeTotale = 0;
            self.rendezvous.sCommentaire = oRdv._RDV_COMMENTAIRE;

            //Date

            //self.rendezvous.sDateMec = null;
            self.rendezvous.sDateReception = oRdv._RDV_DATE;
            self.rendezvous.sDateRestitution = oRdv._RDV_DATE_RESTITUTION;
            self.rendezvous.iHeureReception = oRdv._RDV_HEURE_ARRIVEE;
            self.rendezvous.iHeureRestitution = oRdv._RDV_HEURE_RESTITUTION;
            self.rendezvous.iIdAtelier = oRdv._ATE_ID;
            self.retrieveAteliers(self,function(){
                self.rendezvous.iIdReceptionnaire = oRdv._REC_ID;
                self.rendezvous.iIdVehCourtoisie = oRdv.iIdVehCourtoisie;
                self.rendezvous.bLeClientAttend = (oRdv._RDV_LE_CLIENT_ATTENDS == 1 || oRdv._RDV_LE_CLIENT_ATTENDS == true);
                self.rendezvous.bVehCourtoisie = (oRdv._RDV_VEHICULE_REMPLACEMENT == 1 || oRdv._RDV_VEHICULE_REMPLACEMENT == true);
                if(self.rendezvous.bVehCourtoisie){
                    self.rendezvous.iIdVehCourtoisie = oRdv.iIdVehCourtoisie;
                    self.rendezvous.vehCourtoisie = self.searchVehiculesCourtoisie(self, oRdv.iIdVehCourtoisie,function(){
                        //self.rendezvous.bVehiculeRemplacement = null;

                        self.showFormValidation(self);
                        //self.showFormValidation(self);
                    });
                        
                }else{
                    self.showFormValidation(self);
                }
            });
 
        });
    });
};

Widget3dsoft.prototype.deleteRendezvous = function (self, idRdv) {
    if (confirm(self.sLanguage.RENDEZVOUS_TITRE_CONFIRM_DELETE)) {
        $(self.sClass + ' .widget3Dsoft-message').hide();
        $('#widget3Dsoft-loading').show();
        
        self.ajax('POST',
            this.sServerURL + 'rest/rendezvous/delete' + this.sParamsGet,
            { iIdRendezvous: idRdv },
            function (response) {
                $('.rowdRdv' + idRdv).remove();
            }
        );
    }
}